import { useState } from 'react';
import { AppBar, Box, Typography, useTheme } from '@mui/material';
import Header from 'components/Layouts/components/Header';
import AgencySidebar from './components/AgencySidebar';
import { useLocation } from 'react-router-dom';

type Props = {
  children: JSX.Element;
};

export default function AgencyLayout({ children }: Props) {
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <>
      {location.pathname.includes('agency') && (
        <AppBar
          position='fixed'
          sx={{
            backgroundColor: theme.palette.background.paper,
            boxShadow: 'none',
            borderBottom: '1px solid #E0E0E0',
            background: 'rgb(234 56 76)',
            top: 0,
            zIndex: 100000
          }}
        >
          <Typography fontSize='0.875rem' fontWeight={500} textAlign='center' py={0.5}>
            You are viewing as Agency View
          </Typography>
        </AppBar>
      )}
      <Header onMenuClick={handleDrawerToggle} />
      <Box bgcolor={theme.palette.background.default} display='flex'>
        <AgencySidebar isMenuOpen={mobileOpen} handleClose={handleDrawerToggle} />
        <Box component='main' sx={{ flexGrow: 1, padding: 3, paddingTop: '120px' }}>
          {children}
        </Box>
      </Box>
    </>
  );
}
